import { useState, useMemo } from 'react';
import ResetPresenter from './resetPresenter';
import { Option } from '../../../utils/option';
import { NextRouter } from 'next/router';
import withPageInit from '../../../utils/hooks/withPageInit';
import useEmailInput from '../../../utils/hooks/useEmailInput';
import useFirstTime from '../../../utils/hooks/useFirstTime';

function useResetPage(router: Option<NextRouter>) {
  const [
    email,
    onChangeEmail,
    emailErr,
    setEmail,
    emailHasError,
    setNotTouched
  ] = useEmailInput('');

  const notTouched = useFirstTime(
    [email].some((i) => i.length > 0),
    [email]
  );

  const resetEnabled = useMemo(() => {
    return !emailHasError && !notTouched;
  }, [emailHasError, notTouched]);

  const clearResetForm = () => {
    setEmail('');
    setServerErrMsg('');
    setNotTouched(true);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [serverErrMsg, setServerErrMsg] = useState('');

  const presenter = useMemo(() => {
    return new ResetPresenter(
      router,
      setIsLoading,
      setIsModalOpen,
      setServerErrMsg
    );
  }, []);

  return {
    isLoading,
    isModalOpen,
    email,
    onChangeEmail,
    emailErr,
    serverErrMsg,
    resetEnabled,
    clearResetForm,
    presenter
  };
}

export default withPageInit(useResetPage);
